export enum InvoiceReviewType {
  STANDARD = "STANDARD",
  FASTLANE = "FASTLANE",
  ZERO_TOUCH = "ZERO_TOUCH",
}
